var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 12H21V20L13 20V23H21V31H24V23H32V20L24 20V12Z","fill":"black","key":1})]);
}

Plus.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
